<template>
	<!-- 我的订单 -->
	<div class="allOrder">
		<!-- 标题 -->
		<ul class="aoTitleBox d-rn d-aic d-jcs">
			<li v-for="(item,index) in 6" :key='index' @click="handleOrderType(index)" 
			:class="[!index?'':'apMarLft30','aoTitleBox-itemLiBox','d-cw','d-aic','d-jcc','showHand']">
				<p :style="{color:aOrederIndex==index?'#e62129':'#666666'}">{{index | handleTitTxt}}</p>
				<p :class="[aOrederIndex==index?'selOrType':'noSelOrType']" v-show="true"></p>
			</li>
		</ul>
		
		<!-- 列表头部 -->
		<ul class="aoListTit d-rn d-aic d-jcs">
			<li>订单详情</li>
			<li>收货人</li>
			<li>金额</li>
			<li>订单状态</li>
			<li>操作</li>
		</ul>
		
		<!-- 有数据 -->
		<div class="aoListHas" v-if="aoShopList && aoShopList.length">
			<!-- 每个订单信息 -->
			<ul  v-for="(item,index) in aoShopList" :key='index'>
				<div class="aoListHas-imOrInfo" 
				v-if="item.back_status==0||item.back_status==1||item.back_status==3||item.back_status==5||item.back_status==7">
				<!-- 头部 -->
				<li class="aoListHas-topTit d-rn d-aic d-jcs">
					<p>{{item.back_create_time}}</p>
					<p>订单号：{{item.back_number}}</p>
				</li>
				<!-- 底部 -->
				<div class="aoListHas-btmBox d-rn d-aic d-jcs">
					<!-- 商品头像/名称 -->
					<ul class="aoListHas-btmBox-nameImg d-rn d-aic d-jcc">
						<!-- 左=图片 -->
						<li class="aoListHas-btmBox-nameImg-lftImg">
							<img :src="item.goods_attr_img" alt="" >
						</li>
						<!-- 右=名称，数量 -->
						<li class="aoListHas-btmBox-nameImg-rgtName d-cw d-ais d-jce">
							<p class="txt-cut">{{item.goods_title}}</p>
							<p class="one-txt-cut">数量：{{item.back_num}}</p>
						</li>
					</ul>
					<!-- 收货人 -->
					<ul class="aoListHas-btmBox-ReceivPeo d-rn d-aic d-jcc one-txt-cut">
						<span class="one-txt-cut">
							{{item.addr_name||''}}
						</span>
					</ul>
					<!-- 应付 -->
					<ul class="aoListHas-btmBox-shouldPayNum d-cw d-aic d-jcc">
						<span>应付</span>
						<span>￥{{item.trader_goods_money&&item.back_num?(item.back_num*item.trader_goods_money).toFixed(2):''}}</span>
					</ul>
					<!-- 订单状态 -->
					<ul class="aoListHas-btmBox-orderStus d-cw d-aic d-jcc">
						<li>{{item.back_status |handleGlOrType}}</li>
						<li class="showHand"
						@click="handleOrderDetail(item,index)">订单详情</li>
					</ul>
					<!-- 操作 -->
					<ul class="aoListHas-btmBox-lastBox d-cw d-aic d-jcc">
						<!-- 付款按钮 -->
						<li class="aoListHas-btmBox-lastBox-oneBox showHand"
						@click="handleSubmitOrder(item)" v-if="item.back_status==7">付款</li>
						<li class="aoListHas-btmBox-lastBox-twoBox showHand aoMarTopBtm10" v-if="item.back_status==7" 
						@click="handleOrderDetail(item,index)">修改地址</li>
						<li class="aoListHas-btmBox-lastBox-twoBox showHand" v-if="item.back_status==7"
						 @click="throttle(handleCloseOrder,1500,item,index)">取消订单</li>
						
						<!-- 待生产/生产中 -->
						<li class="aoListHas-btmBox-lastBox-twoBox showHand" v-if="item.back_status==1 || item.back_status==0"
						@click="handleTipsTxt(index)">催促发货</li>
						
						<!-- 待收货 -->
						<li class="aoListHas-btmBox-lastBox-oneBox showHand" v-if="item.back_status==5"
						@click="throttle(handleQrSh,1500,item,index)">确认收货</li>
						<li class="aoListHas-btmBox-lastBox-twoBox showHand aoMarTop10" v-if="item.back_status==5"
						@click="handleOrderDetail(item,index)">查看物流</li>
						
						<!-- 完成订单 -->
						<li class="aoListHas-btmBox-lastBox-twoBox showHand" v-if="item.back_status==3"
						@click="handleDelItemOrder(item,index)">删除订单</li>
					</ul>
				</div>
				</div>
			</ul>
		</div>
		<!-- 无数据 -->
		<ul class="aoListNoData d-cw d-aic d-jcc" v-else>
			<img src="../../../assets/img/privacy/noCollection.png" >
			<p>暂无信息</p>
		</ul>
	</div>
</template>

<script>
	import {
		appUserFindByOrderList,	//查询全部
		appCBackstageCancel,	//取消子订单
		appCBackstageFinish,	//确认收货
		appCBackstageDelByBackId,//删除订单
	} from '@/api/allOrder.js'
	let _self;
	export default {
		name:"",
		data() {
			return {
				// 用户信息
				userInfo:null,
				// 默认显示下标
				aOrederIndex:0,
				
				
				
				// 列表数据
				aoShopList:null,
				// 接口请求状态
				isRsState:false,
				// 提示状态
				tipsState:null,
				jmsId:this.$store.getters.getJmsId,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// 方法监听
			_self.handleEveAllJhCl();
			
			
			// 请求商品全部订单
			_self.handleRequestAllOrder();
		},
		// 方法集
		methods: {
			// 确认收货
			handleQrSh(it,ix){
				// console.log('确认收货的订单信息====》',it);
				
				// 防止频繁请求
				if(_self.isRsState){
					_self.$jgTips('正在请求中，请稍等');
					return false;
				}
				_self.isRsState=true;
				// 确认收货接口请求
				appCBackstageFinish({
					backId:it.back_id,
					userId:_self.userInfo.id
				}).then(res=>{
					// console.log('确认收货接口返回值===',res);
					if(res.code==200){
						_self.$message({
							message:'确认收货成功！',
							type:'success'
						});
						// 刷新订单列表接口
						_self.handleRequestAllOrder();
					}
				}).finally(err=>{
					_self.isRsState=false;
				})
			},
			// 删除当前订单
			handleDelItemOrder(it,ix){
				// 防止频繁请求
				if(_self.isRsState){
					_self.$jgTips('正在请求中，请稍等');
					return false;
				}
				_self.isRsState=true;
				// 确认收货接口请求
				appCBackstageDelByBackId({
					backId:it.back_id,
					userId:_self.userInfo.id
				}).then(res=>{
					// console.log('确认收货接口返回值===',res);
					if(res.code==200){
						_self.$message({
							message:'删除订单成功！',
							type:'success'
						});
						// 深层转移订单列表
						let newArr=JSON.parse(JSON.stringify(_self.aoShopList));
						newArr.splice(ix,1);
						// 重定向
						_self.$set(_self,'aoShopList',newArr)
					}
				}).finally(err=>{
					_self.isRsState=false;
				})
			},
			
			
			// 事件监听
			handleEveAllJhCl(){
				// 监听myInfo滑动到底部===
				_self.$EventBus.$on('orderRequestNext',res=>{
					// console.log('订单组件====接受到请求下一页命令===',res);
					
					// 订单数量+1
					// _self.pageInfo.page++;
					// 请求全部订单
					// _self.handleRequestAllOrder();
				})
			},
			// 进入订单详情===修改地址进入详情修改
			handleOrderDetail(it,ix){
				// console.log('订单信息====',[it,ix]);
				
				// 编码encodeURIComponent() ||  解码decodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify(it));
				console.log('======',it);
				// 跳转到搜索页面并传递搜索信息
				_self.$router.push({path:'/order',query:{id:pageVal}})
			},
			// 催促发货
			handleTipsTxt(val){
				if(_self.tipsState==val){
					_self.$jgTips('请勿频繁催促商家');
					return false;
				}
				_self.tipsState=val;
				
				// 提示催促成功
				_self.$message({
					message:'已成功催促商家！',
					type:'success'
				});
				setTimeout(()=>{
					// 允许再次提示
					_self.tipsState=null;
				},3000)
			},
			// 取消订单
			handleCloseOrder(it,ix){
				// console.log('取消订单===',it);
				// console.log('取消订单===',ix);
				// 阻止频繁请求
				if(_self.isRsState){
					_self.$jgTips('正在请求中，请稍等');
					return false;
				}
				_self.isRsState=true;
				
				// 取消订单接口
				appCBackstageCancel({
					backId:it.back_id
				}).then(res=>{
					if(res.code==200){
						
						_self.$message({
							message:'取消成功',
							type:'success'
						});
						
						//深层转移
						let newList=JSON.parse(JSON.stringify(_self.aoShopList));
						newList.splice(ix,1)
						
						// 重定向
						_self.$set(_self,'aoShopList',newList);
					}
				}).finally(err=>{
					_self.isRsState=false;
				})
			},
			// 子订单支付
			handleSubmitOrder(it){
				// console.log('订单信息===',it);
				let requestNeedData={
					orderInfdo:it,
					pagesId:it.back_id
				}
				// console.log('页面传递==信息',requestNeedData);
				// 编码encodeURIComponent() ||  解码decodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify(requestNeedData));
				// 不保存当前页面跳转==传递下一页信息
				_self.$router.replace({name:'orderXq',query:{info:pageVal}})
				
			},
			
			
			
			
			// 获取全部订单
			handleRequestAllOrder(){
				// 向myInfo.vue传递不需要加载下一页
				_self.$emit('orderHasNext',false)
				
				
				// 请求订单接口
				appUserFindByOrderList({
					userId:_self.userInfo.userId,
					traderId:_self.jmsId,
					backStatus:_self.aOrederIndex==0?'':
					_self.aOrederIndex==1?'7':
					_self.aOrederIndex==2?'0':
					_self.aOrederIndex==3?'1':
					_self.aOrederIndex==4?'5':'3'
				}).then(res=>{
					// console.log('条件接口===',res);
					if(res.code==200){
						_self.aoShopList=res.data;
					}
				}).finally(err=>{
					// 允许再次请求
					_self.isRsState=false;
				})
			},
			// 选择订单类型
			handleOrderType(val){
				if(_self.isRsState){
					_self.$eror('正在请求中！');
					return false;
				}
				_self.isRsState=true;
				
				
				// 允许再次提示
				_self.tipsState=null;
				// 定义选中下标
				_self.aOrederIndex=val;
				// 查询订单
				_self.handleRequestAllOrder();
			}
		},
		// 组件集
		components:{

		},
		mounted() {
			
		},
		watch:{
			
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			// 页面标题
			handleTitTxt(val){
				return !val?'全部订单':
				val==1?'待付款':
				val==2?'待生产':
				val==3?'生产中':
				val==4?'待收货':'已完成'
			},
			// 订单状态
			handleGlOrType(val){
				return val==0?'待生产':
				val==1?'生产中':
				val==3?'已完成':
				val==5?'待收货':
				val==7?'待支付':''
			}
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style lang="scss">
	/* 大盒子 */
	.allOrder{
		width: 100%;
		box-sizing: border-box;
		background: rgba(255,255,255,0.72);
		
		padding: 20px 30px 0px;
		box-sizing: border-box;
		
	}
	
	/* 列表头部 */
	.aoListTit{
		width: 100%;
		height: 44px;
		opacity: 1;
		background: #f5f5f5;
		margin-top: 15px;
		li{
			font-size: 16px;
			font-weight: 400;
			color: #666666;
			letter-spacing: 2px;
		}
		li:nth-of-type(1){
			margin-left: 30px;
		}
		li:nth-of-type(2){
			margin-left: 287px;
		}
		li:nth-of-type(3){
			margin-left: 97px;
		}
		li:nth-of-type(4){
			margin-left: 97px;
		}
		li:nth-of-type(5){
			margin-left: 110px;
		}
	}
	/* 无数据 */
	.aoListNoData{
		width: 100%;
		padding:25px 0 40px;
		box-sizing: border-box;
		img{
			widows: 352px;
			height: 352px;
		}
		p{
			margin-top: 15px;
			
			font-size: 18px;
			font-weight: 400;
			color: #666666;
			letter-spacing: 1px;
		}
	}
	/* 有数据 */
	.aoListHas{
		width: 100%;
		padding-bottom: 20px;
		/* 每个商品订单 */
		&-imOrInfo{
			margin-top: 30px;
			width: 100%;
			
			opacity: 1;
			border: 1px solid #cccccc;
		}
		/* 头部 */
		&-topTit{
			width: 100%;
			height: 36px;
			padding: 0 30px;
			box-sizing: border-box;
			background: #f5f5f5;
			p{
				font-size: 14px;
				font-weight: 400;
				color: #999999;
				letter-spacing: 2px;
			}
			p:nth-of-type(2){
				margin-left: 40px;
			}
		}
		
		/* 底部 */
		&-btmBox{
			width: 100%;
			height: 120px;
			/* 图片，名称 */
			&-nameImg{
				width: 346px;
				height: 100%;
				border-right: 1px solid #ccc;
				box-sizing: border-box;
				
				/* 图片 */
				&-lftImg{
					width: 80px;
					height: 80px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				/* 名称数量 */
				&-rgtName{
					width: 186px;
					margin-left: 20px;
					p{
						width: 100%;
					}
					p:nth-of-type(1){
						font-size: 16px;
						font-weight: 400;
						color: #333333;
						letter-spacing: 2px;
					}
					p:nth-of-type(2){
						margin-top: 13px;
						font-size: 14px;
						font-weight: 400;
						text-align: left;
						color: #999999;
						letter-spacing: 2px;
					}
				}
			}
			/* 收货人 */
			&-ReceivPeo{
				width: 132px;
				padding: 0 5px;
				height: 100%;
				border-right: 1px solid #ccc;
				box-sizing: border-box;
				text-align: center;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				letter-spacing: 2px;
				span{
					display: inline-block;
					width: 100%;
				}
			}
			/* 应付 */
			&-shouldPayNum{
				width: 146px;
				height: 100%;
				border-right: 1px solid #ccc;
				box-sizing: border-box;
				
				span{
					font-size: 16px;
					font-weight: 400;
					color: #000000;
					letter-spacing: 2px;
				}
			}
			/* 状态 */
			&-orderStus{
				width: 150px;
				height: 100%;
				border-right: 1px solid #ccc;
				box-sizing: border-box;
				
				li:nth-of-type(1){
					font-size: 16px;
					font-weight: 400;
					text-align: center;
					color: #ff6e00;
					letter-spacing: 2px;
				}
				li:nth-of-type(2){
					margin-top: 10px;
					
					font-size: 16px;
					font-weight: 400;
					text-align: center;
					color: #666666;
					letter-spacing: 2px;
				}
			}
			/* 操作 */
			&-lastBox{
				flex: 1;
				height: 100%;
				/* 代付款 */
				&-oneBox{
					width: 120px;
					height: 28px;
					opacity: 1;
					border: 1px solid #e62129;
					box-sizing: border-box;
					border-radius: 2px;
					text-align: center;
					line-height: 28px;
					
					font-size: 16px;
					font-weight: 400;
					color: #e62129;
					letter-spacing: 2px;
				}
				&-twoBox{
					font-size: 16px;
					font-weight: 400;
					text-align: center;
					color: #666666;
					letter-spacing: 2px;
				}
			}
		}
	}
	.aoMarTopBtm10{
		margin: 10px 0;
	}
	.aoMarTop10{
		margin-top: 10px;
	}
	
	
	
	
	/* 标题 */
	.aoTitleBox{
		width: 100%;
		&-itemLiBox{
			P:nth-of-type(1){
				font-size: 16px;
				font-weight: 400;
				letter-spacing: 2px;
			}
		}
	}
	/* 外边距30px */
	.apMarLft30{
		margin-left: 30px;
	}
	/* 滑块的选中=未选中样式 */
	.selOrType{
		width: 100%;
		height: 2px;
		margin-top: 5px;
		opacity: 1;
		background: #e62129;
	}
	.noSelOrType{
		width: 100%;
		height: 2px;
		margin-top: 5px;
		opacity: 1;
		background: rgba(255,255,255,0.72);
	}
</style>
